import {
  Box,
  CircularProgress,
  Divider,
  Stack,
  Typography,
} from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import { GetCurrencyFixedToTwo } from "../../../../utils/commonFunctions/GetCurrencyFixedToTwo";
import { ButtonCust } from "../../../widgets";
import styles from "./PayNow.module.scss";
import { CardTypes } from "../../../../enums";
import { getIsCardExpired } from "../../../../utils/commonFunctions/ReusableFunctions";
import envConfig from "../../../../config/env.config.json";
import AutoPaySaveCard from "./AutoPaySaveCard";
import {
  showPayFormFn,
  showSaveCardAlertDialog,
} from "../../../../features/activation/activationSlice";
import { gtmTagManager } from "../../../../utils";
import { gaEvents, gaScreenNames } from "../../../../Types/GoogleAnalytics";

const T6ActivationPayNow = (props: any) => {
  const {
    currentLine,
    payNowConfirm,
    payBtnLoader,
    manageCardFg,
    content,
    autoPayCard,
    setPayBtnLoader,
  } = props;
  const dispatch = useAppDispatch();
  const { isSimInHand = false } = currentLine || {};

  const { monthInAdvanceData, enablePayForm } = useAppSelector(
    (state: any) => state?.activation || {}
  );

  const {
    title,
    info_txt,
    chng_btn,
    due_txt,
    fee_txt,
    discount_txt,
    pay_btn,
    visa,
    discover,
    master_card,
    jcb,
    american_ex,
    promo_img,
    num_mask,
    sub_title,
  } = content?.pay_now;
  let isCardExpired = false;

  let actData: any[] = [
    {
      text: content?.pln_chrgs
        ? `${currentLine?.reachPlanDisplayName} ${content?.pln_chrgs}`
        : currentLine?.reachPlanDisplayName,
      value: monthInAdvanceData?.amount ?? "-",
      id: 1,
    },
    {
      text: discount_txt,
      value:
        monthInAdvanceData?.promoDiscount > 0
          ? monthInAdvanceData?.promoDiscount
          : null,
      id: 3,
    },
    {
      text: fee_txt,
      value: monthInAdvanceData?.taxAmount ?? "-",
      id: 2,
    },
    {
      text: due_txt,
      value: monthInAdvanceData?.amountToPay ?? "-",
      id: 4,
    },
  ];

  if (autoPayCard?.dateOfExpiry) {
    isCardExpired = getIsCardExpired(autoPayCard);
  }

  return (
    <Stack>
      {currentLine?.reachPlanId && (
        <>
          <Box
            className={styles.activation_paynow_card}
            sx={{
              width: { xs: "95%", sm: "50%", md: "40%", lg: "40%" },
              margin: { xs: "40px auto", sm: "60px auto 50px" },
            }}
          >
            <Box
              className={styles.main_container}
              display="flex"
              flexDirection="column"
              alignItems="center"
              textAlign="center"
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  p: { xs: "25px 0px" },
                }}
              >
                {/* <Box
                  component="img"
                  alt={"circular_loader"}
                  src={content?.payment_modal_icon?.data?.[0]?.attributes?.url}
                  sx={{
                    paddingRight: "16px",
                    width: "30px",
                  }}
                /> */}
                <Typography
                  className={styles.heading}
                  sx={{
                    fontSize: { xs: "18px !important", sm: "24px !important" },
                    fontFamily: "var(--font_family_Bold)",
                    textAlign: "center",
                    fontWeight: "var(--font_weight_4)",
                    color: "var(--black)",
                    lineHeight: { xs: "30px", sm: "36px" },
                  }}
                >
                  {title}
                </Typography>
              </Box>
              <Box sx={{ width: "100%", textAlign: "center" }}>
                <Divider
                  style={{ border: "1px solid var(--lightgrey_6)" }}
                ></Divider>
              </Box>
              <Box sx={{ textAlign: "center" }}>
                <Typography
                  sx={{
                    fontSize: "16px",
                    fontFamily: "var(--font_family_Semibold)",
                    // my:{xs:"25px"},
                    mt: { xs: "20px" },
                    mb: { xs: "20px" },
                    color: "var(--text_color)",
                    fontWeight: "var(--font_weight_2)",
                    lineHeight: "26px",
                  }}
                >
                  {currentLine?.esim
                    ? content?.step_txt
                    : content?.step_txt_next}
                </Typography>
              </Box>
              {sub_title ? (
                <Typography
                  className={styles.sub_title}
                  sx={{ marginBottom: "20px", padding: "0 !important" }}
                >
                  {sub_title}
                </Typography>
              ) : null}
              {!monthInAdvanceData ? (
                <Box
                  className={styles.loaderCheck}
                  sx={{ marginBottom: "20px" }}
                >
                  <CircularProgress />
                </Box>
              ) : (
                <>
                  {actData?.map((each) => (
                    <>
                      {each?.id === 3 && each?.value <= 0 ? null : (
                        <Box
                          //   className={styles.row}
                          display="flex"
                          justifyContent="space-between"
                          alignItems="center"
                          p="2px"
                          my="10px"
                          sx={{
                            width: {
                              xs: "91%",
                              sm: "75%",
                              md: "60%",
                              lg: "70%",
                            },
                          }}
                          key={each.id}
                        >
                          <Typography
                            className={styles.row_text}
                            sx={{
                              fontFamily:
                                each.id !== 4
                                  ? "var(--font_family_Regular)"
                                  : "var(--font_family_Semibold)",
                              fontWeight:
                                each.id !== 4
                                  ? "var(--font_weight_0)"
                                  : "var(--font_weight_2)",
                            }}
                          >
                            {each.text}
                          </Typography>
                          <Typography
                            className={styles.row_value}
                            sx={{
                              fontFamily:
                                each.id !== 4
                                  ? "var(--font_family_Regular)"
                                  : "var(--font_family_Semibold)",
                              fontWeight:
                                each.id !== 4
                                  ? "var(--font_weight_0)"
                                  : "var(--font_weight_2)",
                            }}
                          >
                            {each.id === 3
                              ? `-${GetCurrencyFixedToTwo(each.value)}`
                              : GetCurrencyFixedToTwo(each.value)}
                          </Typography>
                        </Box>
                      )}
                    </>
                  ))}
                  {monthInAdvanceData?.couponName && (
                    <Box
                      className={styles.promo_coupon}
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      p="16px"
                      m="20px"
                      sx={{
                        width: {
                          xs: "80%",
                          sm: "75%",
                          md: "60%",
                          lg: "45%",
                        },
                      }}
                    >
                      <img
                        src={promo_img?.data?.attributes?.url}
                        alt={promo_img?.data?.attributes?.alternativeText}
                        style={{
                          width: "22px",
                          height: "22px",
                          marginRight: "10px",
                        }}
                      />
                      {monthInAdvanceData?.couponName}
                    </Box>
                  )}
                  {isSimInHand && envConfig.IS_AUTOPAY_ENABLED && (
                    <AutoPaySaveCard
                      styles={styles}
                      currentLine={currentLine}
                      setPayBtnLoader={setPayBtnLoader}
                      content={content}
                    />
                  )}

                  {!isSimInHand && info_txt && (
                    <Typography
                      className={styles.text1}
                      mb="14px"
                      //   sx={{
                      //     width: { xs: "90%", sm: "75%", md: "60%", lg: "45%" },
                      //   }}
                    >
                      {info_txt}
                    </Typography>
                  )}
                  {autoPayCard?.ccNumberMask && (
                    <>
                      <Box
                        display="flex"
                        alignItems="center"
                        className={styles.image_text_container}
                        padding="14px"
                        sx={{
                          width: {
                            xs: "83%",
                            sm: "71%",
                            md: "56%",
                            lg: "65%",
                          },
                          margin: { sm: "20px 0px 0px" },
                        }}
                        border="1px solid var(--grey-85)"
                        borderRadius="6px"
                      >
                        <img
                          src={
                            autoPayCard?.type?.toUpperCase() === CardTypes?.VISA
                              ? visa?.data?.attributes?.url
                              : autoPayCard?.type?.toUpperCase() ===
                                CardTypes?.MASTERCARD
                              ? master_card?.data?.attributes?.url
                              : autoPayCard?.type?.toUpperCase() ===
                                CardTypes?.JCB
                              ? jcb?.data?.attributes?.url
                              : autoPayCard?.type?.toUpperCase() ===
                                  CardTypes?.AMERICANEXPRESS ||
                                autoPayCard?.type?.toUpperCase() ===
                                  CardTypes?.AMEX
                              ? american_ex?.data?.attributes?.url
                              : discover?.data?.attributes?.url
                          }
                          alt={
                            autoPayCard && autoPayCard.type === CardTypes.VISA
                              ? visa?.data?.attributes?.alternativeText
                              : american_ex?.data?.attributes?.alternativeText
                          }
                          style={{ width: "42px", height: "27px" }}
                        />
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                            alignItems: "center",
                          }}
                        >
                          <Typography
                            className={styles.text2}
                            pl="10px"
                            sx={{
                              color: "var(--black)",
                              fontSize: {
                                xs: "12px !important",
                                sm: "14px !important",
                              },
                              lineHeight: {
                                xs: "25px !important",
                                sm: "28px !important",
                              },
                            }}
                          >
                            {num_mask} {autoPayCard?.ccNumberMask}
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: {
                                xs: "12px !important",
                                sm: "16px !important",
                              },
                              lineHeight: {
                                xs: "21px !important",
                                sm: "28px !important",
                              },
                            }}
                            className={styles.text3}
                            ml="10px"
                            onClick={manageCardFg}
                          >
                            {chng_btn}
                          </Typography>
                        </Box>
                      </Box>
                    </>
                  )}
                  {autoPayCard?.ccNumberMask ||
                  (isSimInHand &&
                    !envConfig?.ENABLE_ONE_TIME_CHARGES_PAYMENT_FOR_SIM_IN_HAND) ? (
                    <>
                      <ButtonCust
                        variantType={envConfig.PRIMARY_BUTTON_TYPE}
                        sx={{
                          m: "30px 0 30px 0",
                          padding: "13px 23px",
                        }}
                        onClick={() => {
                          isSimInHand &&
                          !envConfig?.ENABLE_ONE_TIME_CHARGES_PAYMENT_FOR_SIM_IN_HAND
                            ? () => {
                                if (enablePayForm) {
                                  dispatch(showPayFormFn(true));
                                  setPayBtnLoader(true);
                                } else {
                                  dispatch(showSaveCardAlertDialog(true));
                                }
                              }
                            : payNowConfirm();

                          gtmTagManager({
                            event: gaEvents?.activationPaymentInitiated,
                            screen_name: gaScreenNames?.activation,
                          });
                        }}
                        loading={payBtnLoader}
                        disabled={isCardExpired}
                      >
                        {pay_btn}
                      </ButtonCust>
                    </>
                  ) : (
                    <Box sx={{ pt: 4 }}></Box>
                  )}
                </>
              )}
            </Box>
          </Box>
        </>
      )}
    </Stack>
  );
};
export default T6ActivationPayNow;
